import { useEffect, useState } from 'react'
import { analyticsConsent, ga4Available, setAnalyticsConsent } from '../../lib/ga4'

export function AnalyticsConsent() {
  const [open, setOpen] = useState(() => ga4Available() && analyticsConsent() === null)
  useEffect(() => {
    const update = () => setOpen(ga4Available() && analyticsConsent() === null)
    window.addEventListener('axxiz-analytics-consent', update)
    const show = () => setOpen(ga4Available())
    window.addEventListener('axxiz-analytics-settings', show)
    return () => {
      window.removeEventListener('axxiz-analytics-consent', update)
      window.removeEventListener('axxiz-analytics-settings', show)
    }
  }, [])
  if (!open) return null
  return <section aria-label="Analytics preferences" style={{
    position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 150,
    maxWidth: 620, margin: '0 auto', padding: 20, borderRadius: 12,
    border: '1px solid var(--border-subtle)', background: 'var(--bg-1)',
    color: 'var(--fg-1)', boxShadow: 'var(--shadow-md)',
  }}>
    <p style={{ marginBottom: 12 }}>Allow Google Analytics cookies to help us understand visits and enquiries? You can change your choice using Analytics preferences in the footer.</p>
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
      <button onClick={() => setAnalyticsConsent('granted')} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid var(--navy-700)', background: 'var(--navy-700)', color: 'var(--bg-1)', cursor: 'pointer' }}>Allow analytics</button>
      <button onClick={() => setAnalyticsConsent('denied')} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-1)', color: 'var(--fg-1)', cursor: 'pointer' }}>Decline analytics</button>
      <a href="/privacy" style={{ alignSelf: 'center', color: 'var(--navy-700)' }}>Read privacy policy</a>
    </div>
  </section>
}
